import React, { forwardRef, useImperativeHandle, useState } from "react"

import { AttributeRef } from "./AddAttribute";
import { InputBasic } from "../../components/utils/InputBasic"
import { InputTextArea } from "../../components/utils/InputTextArea"
import { G_onInputChangeHandler, G_onInputBlurHandler } from "../../components/utils/InputHandlers"

interface SectionProps {
    whatToAdd: any;
    posting: boolean,
}

export const SectionAttribute = forwardRef<AttributeRef, SectionProps>(({ whatToAdd, posting }, ref) => {
    const [state, setstate] = useState({
        httpStatus: 200,
        input: {
            name: '',
            subtitle: ''
        },
        errors: {
            name: '',
            subtitle: ''
        }
    })

    const onChangeHandler = (e: any) => {
        if (!posting) {
            let { input } = state
            let { errors } = state
            let output: any = G_onInputChangeHandler(e)

            const updatedInput = {
                ...input,
                [e.target.name]: output.value
            };

            const updatedErrors = {
                ...errors,
                [e.target.name]: output.error
            };

            setstate((prev) => ({
                ...prev,
                input: updatedInput,
                errors: updatedErrors,
            }));
        }
    }

    const targetLength = (name: string) => {
        switch (name) {
            case 'subtitle':
                return {
                    min: 5,
                    max: 70
                };

            default:
                return {
                    min: 3,
                    max: 30
                };
        }
    }

    const onInputBlur = (e: any) => {
        if (!posting) {
            let { input } = state
            let { errors } = state

            const target0 = targetLength(e.target.name)
            let output: any = G_onInputBlurHandler(e, '', target0.min, target0.max)

            const updatedInput = {
                ...input,
                [e.target.name]: output.value
            };

            const updatedErrors = {
                ...errors,
                [e.target.name]: output.error
            };

            setstate((prev) => ({
                ...prev,
                input: updatedInput,
                errors: updatedErrors,
            }));
        }
    }

    useImperativeHandle(ref, () => ({
        integrityCheck: (e: any) => {
            let { input } = state
            const inputArray = Object.keys(input)

            let passedValidation = true
            let attributes = input

            inputArray.forEach((inputObject: any) => {
                let oTarget = e.target[inputObject]

                const event = {
                    target: {
                        name: oTarget.name,
                        required: oTarget.required,
                        value: oTarget.value.trim(),
                    }
                }

                onInputBlur(event)
            })

            let { errors } = state
            const errorArray = Object.keys(errors)

            errorArray.forEach((errorObject) => {
                if (errors[errorObject].length > 0) {
                    passedValidation = false
                }
            })

            return {
                passedValidation,
                attributes
            }
        },
    }));

    return (
        <React.Fragment>
            <div className="w-full mb-3">
                <p className="text-base text-slate-900 dark:text-white flex items-center gap-x-3 py-2">
                    <span className={`fa-light ${whatToAdd.icon} fa-xl`}></span>
                    {whatToAdd.name}
                </p>

                <p className="text-sm mb-3">
                    Group related fields, e.g. 'General Details' to capture name, description, and status.
                </p>
            </div>

            <div className="w-full">
                <div className="mb-3">
                    <InputBasic
                        name={"name"}
                        required={true}
                        label={"Section Title"}
                        posting={posting}
                        value={state.input.name}
                        error={state.errors.name}
                        blurHandler={onInputBlur}
                        changeHandler={onChangeHandler}
                    />
                </div>

                <div className="mb-3">
                    <InputTextArea
                        name={"subtitle"}
                        required={true}
                        label={"Subtitle"}
                        posting={posting}
                        value={state.input.subtitle}
                        error={state.errors.subtitle}
                        blurHandler={onInputBlur}
                        changeHandler={onChangeHandler}
                    />
                </div>
            </div>
        </React.Fragment>
    )
})